import React, { useState } from "react";
import axios from "axios";
import "./OtpLogin.css";
import { FaMobileAlt, FaShieldAlt, FaArrowRight } from "react-icons/fa";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

const OtpLogin = () => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const sendOtp = async () => {
    if (mobile.length !== 10) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }
    setLoading(true);
    try {
      await api.post("/api/auth/send-otp", { mobile });
      setStep(2);
    } catch (err) {
      alert("Failed to send OTP. Please try again.");
    }
    setLoading(false);
  };

  const verifyOtp = async () => {
    setLoading(true);
    try {
      const res = await api.post("/api/auth/verify-otp", { mobile, otp });
      localStorage.setItem("company", JSON.stringify(res.data.company));
      window.location.replace("/");
    } catch (err) {
      alert("Invalid OTP code");
    }
    setLoading(false);
  };

  return (
    <div className="otp-premium-wrapper">
      {/* Decorative Background Elements */}
      <div className="bg-blob blob-blue"></div>
      <div className="bg-blob blob-orange"></div>

      <div className="otp-glass-card">
        <div className="otp-header">
          <div className="icon-badge">
            {step === 1 ? <FaMobileAlt /> : <FaShieldAlt />}
          </div>
          <h2>{step === 1 ? "Welcome Back" : "Verify Identity"}</h2>
          <p>
            {step === 1 
              ? "Enter your mobile to access your business dashboard" 
              : `Enter the code sent to +91 ${mobile}`}
          </p>
        </div>

        <div className="otp-body">
          {step === 1 ? (
            <div className="input-group">
              <span className="country-code">+91</span>
              <input
                type="tel"
                placeholder="Mobile Number"
                value={mobile}
                maxLength="10"
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
              />
              <button className="btn-premium" onClick={sendOtp} disabled={loading}>
                {loading ? "Processing..." : <>Continue <FaArrowRight /></>}
              </button>
            </div>
          ) : (
            <div className="input-group">
              <input
                type="text"
                className="otp-input-field"
                placeholder="6-Digit OTP"
                value={otp}
                maxLength="6"
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
              />
              <button className="btn-premium btn-orange" onClick={verifyOtp} disabled={loading}>
                {loading ? "Verifying..." : "Verify & Login"}
              </button>
              <p className="resend-text" onClick={() => setStep(1)}>
                Change Number?
              </p>
            </div>
          )}
        </div>

        <div className="otp-footer">
          <p>Secure login powered by <span>BizzMark India</span></p>
        </div>
      </div>
    </div>
  );
};

export default OtpLogin;